module.exports = __webpack_public_path__ + "static/media/finOps.5db29645.svg";